<template>
  <img :src="chip" class="chip-bet">
</template>

<script>
import Chip1 from "@images/chip_1.png";
import Chip5 from "@images/chip_5.png";
import Chip10 from "@images/chip_10.png";
import Chip50 from "@images/chip_50.png";
import Chip100 from "@images/chip_100.png";
import Chip500 from "@images/chip_500.png";
import Chip1k from "@images/chip_1k.png";
import Chip5k from "@images/chip_5k.png";
import Chip10k from "@images/chip_10k.png";
import Chip50k from "@images/chip_50k.png";
import Chip100k from "@images/chip_100k.png";
import Chip500k from "@images/chip_500k.png";
import Chip1m from "@images/chip_1m.png";

export default {
  props: {
    value: { type: String, default: "" }
  },
  computed: {
    chip: function(){
      let result = "";
      switch(this.value){
        case "1": result = Chip1; break;
        case "5": result = Chip5; break;
        case "10": result = Chip10; break;
        case "50": result = Chip50; break;
        case "100": result = Chip100; break;
        case "500": result = Chip500; break;
        case "1k": result = Chip1k; break;
        case "5k": result = Chip5k; break;
        case "10k": result = Chip10k; break;
        case "50k": result = Chip50k; break;
        case "100k": result = Chip100k; break;
        case "500k": result = Chip500k; break;
        case "1m": result = Chip1m; break;
      }
      return result;
    },
  },
}
</script>

<style>

</style>
